export default {
  loggingMethods: [],
  loading: false
}
